import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import { fetchAllUAuditLog, fetchFormDatas } from '../../redux/actions/usersActions';
import { createErrorMessage } from '../../helpers/notification';

class AuditLogContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      auditTypes: [],
      items: [],
      filters: { id: 20 },
    };

    this.columns = [
      {
        key: 'id', name: '#', width: '60px', search: true, type: 'number',
      },
      {
        key: 'usuario', name: 'Usuario', search: true, width: '80px',
      },
      {
        key: 'tipo',
        name: 'Tipo',
        search: true,
        type: 'select',
        searchProps: {
          options: this.getAuditTypes,
        },
      },
      {
        key: 'fecha',
        name: 'Fecha',
        search: true,
        type: 'date',
        format: (row) => {
          const style = { dateStyle: 'short', timeStyle: 'medium' };
          return new Intl.DateTimeFormat('en-GB', style).format(new Date(row.fecha));
        },
      },
      {
        key: 'nombreTabla', name: 'Tabla', search: true,
      },
      {
        key: 'clavePrimaria', name: 'Clave Primaria', search: false,
      },
      {
        key: 'columnasAfectadas', name: 'Columnas Afectadas', search: false,
      },
      {
        key: 'valoresAnteriores', name: 'Valores Anteriores', search: false,
      },
      {
        key: 'valoresNuevos', name: 'Valores Nuevos', search: false,
      },
    ];
  }

  componentDidMount() {
    this.fetchDatasList();
  }

  updateTable = (page, pageSize, filters = {}) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters,
    });
    fetchAllUAuditLog({
      pageInfo: {
        page,
        pageSize,
        filters,
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de cambios');
      },
    });
  }

  fetchDatasList = () => {
    this.setState({
      loading: true,
    });

    fetchFormDatas({
      onSuccess: (data) => {
        this.setState({
          auditTypes: data.auditTypes,
          loading: false,
        });
        const { page, pageSize } = this.state;
        this.updateTable(page, pageSize);
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  getAuditTypes = () => {
    const { auditTypes } = this.state;

    return auditTypes || [];
  };

  showData = (data) => {
    const { history } = this.props;
    history.push(`/pages/users/show_audit_log/${data.id}`);
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;

      this.updateTable(1, pageSize, { ...values, tipo: values.tipo ? values.tipo.value : 0 });
    }
  };


  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Auditor&iacute;a de cambios</h3>
          </Col>
        </Row>
        <Row>
          {loading ? <Col md={12}><h3 className="page-subhead subhead">Cargando...</h3></Col>
            : (
              <DataTable
                title="Listado de todos los cambios del sistema"
                columns={this.columns}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                getGridActions={key => this.getGridActions(key)}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(AuditLogContainer);
